import React, { Component } from 'react';
import { lang } from '../../il8n/lang';
import { connect } from 'react-redux';

import './Variants.css';

import { breakSmall,cdnBase } from '../../const';

import ReactGA from 'react-ga';

/**
 * Home
 * @constructor
 */

class Variants extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...props,
      filter: 'nummybay',
    };

    this.sec = lang.home.variants;

    this.updateDimensions = this.updateDimensions.bind(this)
    this.createFilterBtns = this.createFilterBtns.bind(this)
    this.createProfile = this.createProfile.bind(this)
  }
  componentDidMount() {
    this.updateDimensions()
    window.addEventListener("resize", this.updateDimensions);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions.bind(this));
  }

  updateDimensions(){
    if (window.innerWidth >= breakSmall) {
      this.setState({mobile: false})
    }else{
      this.setState({mobile: true})

    }
  }

  createFilterBtns(gaToggle){
    let btns = []

    Object.keys(this.sec.profiles).forEach( (key, i) => {
      let profile = this.sec.profiles[key]
      
      let btnclass = ''

      if (this.state.filter === key) {
        btnclass = 'mod-selected';
      }

      let btn = 
        <button className={"variants-filter-btn "+ btnclass}  key={btnclass+i} onClick={ ()=>{ 
        this.setState({ filter: key });
        if(gaToggle){
          ReactGA.event({
                 category: 'worlds',
                 action: 'world filter',
                 value: key
               });
        }
        
      } } >
        <img src={profile.thumbnail} alt={'filter button for '+ profile.header}/>
      <p>{profile.header}</p>
      </button>
      btns.push(btn)
    })
    return btns;

  }

  createProfile(){

    return <div className="variants-maincontent"> 
      <div className="variants-textblock desktop">
        <h1 className={this.sec.profiles[this.state.filter].id}>{this.sec.profiles[this.state.filter].header}</h1>
        <p>{this.sec.profiles[this.state.filter].copy}</p>
      </div>

      <div className="variants-imageblock" >
        <img className="variants-imageblock-profileimg" src={ this.sec.profiles[this.state.filter].bgImage } alt={this.sec.profiles[this.state.filter].bgImage_alt } />
      </div>
    </div>
  }
  
  render() {
    let sec = this.sec;
    let {gaToggle} = this.props;

    if(sec){
      return (
        <div className='wrap'>
         <div className="variants">
           <div className="variants-header">
             <h1 className="variants-header-big">{sec.header}</h1>
           </div>
           <div className="variants-filter">
             {this.createFilterBtns(gaToggle)}
           </div>
           {this.createProfile()}
         </div>
       </div>
     )
    }else{
      return(<div>there is no varients in the lang file</div>)
    }
  }
}



function mapStateToProps(state) {
  return {
    gaToggle: state.gaToggle
  };
}

export default connect(mapStateToProps)(Variants);



// WEBPACK FOOTER //
// ./src/components/Variants/Variants.js